import { LoadingOverlay } from '@mantine/core';

const StandardLoadingOverlay = ({ visible }) => (
    <LoadingOverlay visible={visible} zIndex={1000} overlayProps={{ radius: 'sm', blur: 2 }} />
);

export default StandardLoadingOverlay;
